/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import * as Yup from 'yup';
import { useIMask } from 'react-imask';
import Cookies from 'js-cookie';
import axios from 'axios';
import environment from "../../../environment";

const schema = Yup.object({
  first_name: Yup.string()
    .required("El campo nombre es obligatorio"),
  last_name: Yup.string()
    .required("El campo nombre es obligatorio"),
  email: Yup.string()
    .required("El email es obligatorio")
    .email("El email no tiene un formato válido"),
  phone: Yup.string()
    .required("El telefono es obligatorio"),
  comment: Yup.string()
    .required("La consulta es obligatoria"),
});

const initialValues = {
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  text: "",
  origin: "Formulario página web",
  asset_id: "",
  comment: ""
}

const ContactForm = ({ property }) => {
  const [color, setColor] = useState(null);
  const [msj, setMsj] = useState(null);
  const [render, setRender] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [datos, setDatos] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (localStorage.getItem('isFirstTime') && typeof localStorage.getItem('isFirstTime') === 'string') {
      setIsFirstTime(JSON.parse(localStorage.getItem('isFirstTime')));
    }
  }, []);

  useEffect(() => {
    if (Cookies.get('user') && !isFirstTime) {
      setDatos(({ ...datos, ...JSON.parse(Cookies.get('user')) }));
    }
  }, [isFirstTime]);

  const { ref } = useIMask({ mask: '{+}5600000000000' }, {
    onAccept: (value) => {
      setDatos({
        ...datos,
        phone: value,
      });
    }
  });


  useEffect(() => {
    (isSent) ? setColor(true) : setColor(false);
  }, [isSent]);

  const handleInputChange = (event) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
      asset_id: property?.data?.publication_id,
      full_name: `${datos.first_name} ${datos.last_name}`,
      text: `Consulta por la propiedad CAP ${property?.data?.publication_id}`,
    });
  };

  const Close = () => {
    setRender(false);
  };

  const saveContact = async (event) => {
    event.preventDefault();
    const text = `${datos.text} - ${comment}`;
    try {
      await schema.validate(datos, {
        abortEarly: false,
      });
      let utm_cookie = {}
      if (Cookies.get('utm')) {
        utm_cookie = JSON.parse(Cookies.get('utm'));
      }
      const response = await axios.post(`${environment.ENDPOINT_CAPIRENTBACKEND}/portal/lead`, { ...datos, text, ...utm_cookie });
      if (response.status === 201) {
        Cookies.set('user', JSON.stringify({ email: datos.email, first_name: datos.first_name, last_name: datos.last_name, phone: datos.phone }));
        setMsj('¡Mensaje enviado, gracias por tu interés!');
        setRender(true);
        setIsSent(true);
        if (Cookies.get('user')) {
          setDatos(({ ...initialValues, ...JSON.parse(Cookies.get('user')) }));
        } else {
          setDatos({ ...initialValues })
        }
        localStorage.setItem('isFirstTime', JSON.stringify(false));
        setErrors({})
      } else {
        setMsj("Disculpa, hubo un error. Inténtalo nuevamente más tarde.");
        setRender(true);
        setIsSent(false);
        setErrors({})
      }
    } catch (err) {
      const validationErrors = {};
      err.inner.forEach((error) => {
        if (error.path && !validationErrors[error.path]) {
          validationErrors[error.path] = error.message;
        }
      });
      setErrors(validationErrors)
    }
  }

  return (
    <>
      <form className="row pt-3 px-4 pb-2" onSubmit={saveContact}>
        <input type="hidden" name="asset_id" value={property?.data?.publication_id} onChange={handleInputChange} />
        <div className="form-group pb-3">
          <input
            // required
            type="text"
            placeholder="E-mail"
            className="custom-input w-100 microcopy-light"
            onChange={handleInputChange}
            name="email"
            value={datos.email}
          />
          {errors.email && (
            <small className="text-danger microcopy-light">{errors.email}</small>
          )}
        </div>
        <div className="form-group pb-3">
          <input
            // required
            type="text"
            placeholder="Nombres"
            className="custom-input w-100 microcopy-light"
            onChange={handleInputChange}
            name="first_name"
            value={datos.first_name}
          />
          {errors.first_name && (
            <small className="text-danger microcopy-light">{errors.first_name}</small>
          )}
        </div>
        <div className="form-group pb-3">
          <input
            // required
            type="text"
            placeholder="Apellidos"
            className="custom-input w-100 microcopy-light"
            onChange={handleInputChange}
            name="last_name"
            value={datos.last_name}
          />
          {errors.last_name && (
            <small className="text-danger microcopy-light">{errors.last_name}</small>
          )}
        </div>
        <div className="form-group pb-3">
          <input
            ref={ref}
            // required
            type="tel"
            placeholder="Teléfono"
            className="custom-input w-100 microcopy-light"
            onChange={handleInputChange}
            name="phone"
            maxLength="15"
            value={datos.phone}
          />
          {errors.phone && (
            <small className="text-danger microcopy-light">{errors.phone}</small>
          )}
        </div>

        <div className="form-group pb-3">
          <textarea
            className="custom-textarea w-100 microcopy-light pt-2"
            name="comment"
            placeholder="Ingresa tu consulta"
            value={datos.comment}
            rows="3"
            style={{ resize: 'none' }}
            onChange={(event) => {
              setComment(event.target.value);
              handleInputChange(event);
            }}
          />
          {errors.comment && (
            <small className="text-danger microcopy-light">{errors.comment}</small>
          )}
        </div>
        <div className="form-group pb-2 d-none">
          <textarea
            className="custom-textarea w-100 microcopy-light pt-2"
            value={`Consulta por la propiedad CAP ${property?.data?.id}`}
            name="text"
            rows='4'
            style={{ resize: 'none' }}
            onChange={handleInputChange}
          />
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="btn button-style form-button microcopy-bold text-white w-75">
            Enviar solicitud
          </button>
        </div>
      </form>

      {render && (
        <div
          className={
            color
              ? "alert fade show alert-success"
              : "alert fade show alert-warning"
          }
          role="alert"
        >
          <strong>{msj}</strong>
          <a
            type="button"
            onClick={Close}
            className="position-x close text-decoration-none p-3 text-secondary"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </a>
        </div>
      )}
    </>
  );
};

export default ContactForm;
